export const RECOMMENDED_MARKER_NAME = 'RECOMMENDED';
export const RECOMMENDED_CATEGORY_ID = 'Recommended';

export const GREEN_BADGE_COLOR = 'green';